module.exports = __webpack_public_path__ + "media/images/turnkey-4d002b0a.png";